import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  searchDateFrom,
  searchStore,
  type
) => {

  return await GET(
    `/admin/matka/bid-cutting?page=${currentPage || 1}&per_page=${perPage || 10}&from=${searchDateFrom || ""}&store_id=${searchStore || ""}&type=${type || ""}`, {}, process.env.REACT_APP_MATKA_BASE_URL
  );
};

